import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
`

export const ContainerMain = styled.div`
  width: 70%;
`

export const ContainerLink = styled.div`
  margin-bottom: 8px;
`

export const Conteudo = styled.div`
  margin-left: 30px;
`

export const Secao = styled.section`
  /* Cada campo do último ContainerDados de uma seção usa semMargemAbaixo
     (ver JSX) para zerar seu margin-bottom embutido — assim o único espaço
     entre seções é este padding-top, sempre igual, sem depender de qual
     componente veio por último. */
  padding-top: 40px;

  &:first-of-type {
    padding-top: 0;
  }

  /* O SubTitulo compartilhado tem margin-bottom: 27px — reduzido aqui para o
     título ficar mais próximo dos campos da própria seção. */
  h3 {
    margin-bottom: 12px;
  }
`

export const ContainerDados = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
`

export const ContainerDadosGrande = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-right: 19px;
  }
`

export const ContainerDadosMedio = styled.div`
  width: 50%;

  &:not(:last-child) {
    margin-right: 19px;
  }
`

export const ContainerDadosPequeno = styled.div`
  width: 25%;

  &:not(:last-child) {
    margin-right: 19px;
  }
`

export const ContainerNavegacao = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const ContainerAcoes = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 30px;

  & > button:last-child {
    margin-left: 19px;
  }
`

/** Resumo do curso da turma escolhida — leitura, não editável. */
export const ResumoTurma = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 24px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${Cores.FUNDO};

  span.rotulo {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    color: ${Cores.CINZA_2};
  }

  span.valor {
    font-size: 14px;
    font-weight: 600;
    color: ${Cores.CINZA_1};
  }
`

export const Tabela = styled.table`
  margin: 20px 0 27px 0;
  font-family: 'Saira', sans-serif;
  font-size: 12px;
  color: #191414;
  border-collapse: collapse;
  border: 1px solid ${Cores.CINZA_3_CLARO};
  width: 100%;

  th {
    background: ${Cores.CINZA_HEAD_TABLE};
    color: ${Cores.PRETO};
    font-family: 'Saira-Semi-Bold', sans-serif;
    font-weight: 600;
    font-size: 14px;
    padding: 12px;
    border-bottom: none;
    text-transform: uppercase;
  }

  th:first-child {
    border-top-left-radius: 8px;
  }

  th:last-child {
    border-top-right-radius: 8px;
  }

  tbody {
    line-height: 125%;

    tr:first-child {
      border-top: 2px solid ${Cores.CINZA_3_CLARO};
    }

    tr {
      height: 48px;
      border: 1px solid ${Cores.FUNDO};
      border-bottom: none;

      &:last-child {
        border-bottom: 1px solid ${Cores.FUNDO};
      }

      &.par {
        background: ${Cores.FUNDO};
      }

      td,
      th {
        padding: 0 12px;
      }

      &:hover {
        border: 1px solid ${Cores.SECUNDARIA_1};
      }

      /* Linha ilustrativa da taxa: não é editável, então não reage ao mouse. */
      &.taxa {
        background: ${Cores.CINZA_3_MAIS_CLARO};
        color: ${Cores.CINZA_2};
        font-style: italic;

        &:hover {
          border: 1px solid ${Cores.FUNDO};
        }
      }
    }
  }
`

/** Aviso curto abaixo de um campo ou dentro de uma célula. */
export const Aviso = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: ${Cores.CINZA_2};
`

export const ContainerBotaoIcone = styled.div`
  button {
    width: 36px;
    height: 36px;
    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    svg {
      width: 24px;
      height: 24px;
      fill: ${Cores.CINZA_2};
    }

    &:hover {
      background: ${Cores.CINZA_3_MAIS_CLARO};

      svg {
        fill: ${Cores.SECUNDARIA_1};

        path {
          fill: ${Cores.SECUNDARIA_1};
        }
      }
    }
  }
`

export const SemDados = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
  color: ${Cores.CINZA_2};
  font-size: 14px;
`

/** Título da seção com o botão de ação à direita. */
export const CabecalhoSecao = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`

/** Campo exibido só para leitura, no lugar de um input desabilitado. */
export const CampoLeitura = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span.rotulo {
    font-size: 12px;
    color: ${Cores.CINZA_2_CLARO};
  }

  span.valor {
    font-size: 14px;
    font-weight: 600;
    color: ${Cores.CINZA_1};
    padding: 10px 0;
  }

  span.ajuda {
    font-size: 11px;
    color: ${Cores.CINZA_2};
  }
`

/** Link para abrir turma/curso em outra aba, sem perder o formulário. */
export const LinkExterno = styled.a`
  color: ${Cores.SECUNDARIA_1_ESCURO};
  text-decoration: none;
  font-weight: 600;

  :hover {
    text-decoration: underline;
  }

`

/** Caixa de dica informativa (mesmo padrão de background-services/styles.ts). */
export const CaixaAviso = styled.div`
  /* Respiro dos dois lados: acima separa da linha Turma/Validade, abaixo do resumo do curso. */
  margin: 20px 0 16px;
  padding: 14px 16px;
  border-radius: 8px;
  background: ${Cores.ATENCAO_FUNDO};
  border-left: 3px solid ${Cores.ATENCAO};
  color: ${Cores.ATENCAO_ESCURO};
  font-size: 13px;
  line-height: 1.6;

  a {
    margin-left: 4px;
    white-space: nowrap;
  }
`
